require('../modules/web.immediate');
module.exports = require('../modules/_core').setImmediate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/jszip/node_modules/core-js/library/fn/set-immediate.js
// module id = 607
// module chunks = 0